module.exports = __webpack_public_path__ + "images/28da816fe20f622a5ae4c7065fd4b6a8.png";